module.exports = __webpack_public_path__ + "static/media/muscle_back_10.da532431.png";